import React from 'react';

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/ux-common/components/accordion/accordion';
import { Header, HeaderTitle } from '@/ux-common/components/header/header';
import { Typography } from '@/ux-common/components/typography/typography';

interface PreviewSectionProps {
  /** Section heading displayed in the accordion trigger (e.g. "Settings"). */
  title: string;
  /** Child components (typically `PreviewItem` rows) rendered inside the section. */
  children?: React.ReactNode;
}

/**
 * PreviewSection
 *
 * Accordion-based group that wraps related preview items under a collapsible title.
 * Expanded by default. Used to organize pending changes by category
 * (e.g. "Settings", "Sequencer Settings").
 */
export const PreviewSection = ({ title, children }: PreviewSectionProps): React.ReactElement => {
  return (
    <Accordion type="multiple" defaultValue={[title]}>
      <AccordionItem value={title}>
        <AccordionTrigger>
          <Header>
            <HeaderTitle>
              <Typography as="h3" className="text-nav-header">
                {title}
              </Typography>
            </HeaderTitle>
          </Header>
        </AccordionTrigger>
        <AccordionContent className="space-y-thin">{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
